import { formatDateString } from "@/v2-common/utils/utils.date"
import Badge, { type BadgeProps } from "@/v2-backoffice-client/components/badge"

export type LicensePlanDeprecatedBadgeProps = Omit<
  BadgeProps,
  "variant" | "children" | "tooltip"
> & {
  deprecatedAt: string | null | undefined
  successorPlanName?: string | null
  deprecationNote?: string | null
}

// The one "this license is being retired" marker, rendered next to the license name
// everywhere licenses show up (Licenses board, customer panel, license
// panel) so nobody extends or upsells on a license that is being migrated away
// from. Renders nothing while the license is live — callers don't need to guard.
function LicensePlanDeprecatedBadge(props: LicensePlanDeprecatedBadgeProps) {
  const { deprecatedAt, successorPlanName, deprecationNote, ...badgeProps } =
    props
  if (!deprecatedAt) return null

  return (
    <Badge
      variant="critical"
      size="tiny"
      tooltip={
        <div className="max-w-64 space-y-1">
          <p>Deprecated {formatDateString(deprecatedAt)}.</p>
          {successorPlanName && <p>Suggested successor: {successorPlanName}</p>}
          {deprecationNote && (
            <p className="text-muted-foreground">{deprecationNote}</p>
          )}
        </div>
      }
      {...badgeProps}
    >
      Deprecated
    </Badge>
  )
}

export default LicensePlanDeprecatedBadge
